import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Pensionarer = lazy(() => import("@/pages/elavtal/Pensionarer"));

export const Route = createFileRoute("/elavtal/pensionar")({
  head: () => seoHead("/elavtal/pensionar"),
  component: () => <Pensionarer />,
});
